export interface AdminUserSummary {
  userId: number;
  email: string | null;
  displayName: string | null;
  authProvider: string | null;
  emailVerified: boolean;
  roles: string[];
  adsCreated: number;
  aiAdsCreated: number;
  campaignsCreated: number;
  runsBooked: number;
  subscriptionTier: string | null;
  subscriptionStatus: string | null;
  creditsUsedThisPeriod: number | null;
  aiAdsThisPeriod: number | null;
}

export interface AdminUserOrg {
  id: number;
  name: string | null;
  category: string | null;
}

export interface AdminUserDetail {
  summary: AdminUserSummary;
  organizations: AdminUserOrg[];
}

/** Roles surfaced in the filter dropdown (subset of apiserver SupportedRoles). */
export const FILTERABLE_ROLES = [
  'ROLE_USER',
  'ROLE_DRIVER',
  'ROLE_ADMIN',
  'ROLE_PARTNER',
  'ROLE_BUSINESS',
  'ROLE_ADVIEWER',
  'ROLE_SCREEN'
];
